import { render, staticRenderFns } from "./collapseWraper.vue?vue&type=template&id=eff221a2"
import script from "./collapseWraper.vue?vue&type=script&lang=js"
export * from "./collapseWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports